import { IonButton, IonCol, IonImg, IonRow, IonText } from "@ionic/react";
import { useContext } from "react";

import { ApiTokenContext } from "@/contexts/api-token/ApiContextWrapper";
import { createNavigationProps } from "@/utils/common";
import {
  DASHBOARD_MENU_ITEM,
  GET_STARTED_MENU_ITEM,
  LOGIN_MENU_ITEM,
} from "@/utils/constants/menu";
import "./Intro.css";
function IntroSection({ id }: { id?: string }) {
  const { token } = useContext(ApiTokenContext);
  const isLoggedIn = Boolean(token);

  return (
    <IonRow className="intro-section ion-justify-content-center" id={id}>
      <IonCol className="intro-main ">
        <IonRow className="ion-justify-content-center">
          <IonCol>
            <IonText className="intro-title">
              <span className="title">myFirePlane:</span> Your complete aerial
              firefighting fleet management solution.
            </IonText>
          </IonCol>
        </IonRow>
        <IonRow>
          <IonText className="sub-text">
            Simplify tracking, maintenance, and operations for your single
            engine air tankers with our comprehensive cloud-based platform
          </IonText>
        </IonRow>
        <IonRow>
          <IonButton
            size="large"
            color="secondary"
            {...createNavigationProps(
              isLoggedIn ? DASHBOARD_MENU_ITEM.linkTo : GET_STARTED_MENU_ITEM.linkTo,
            )}
          >
            {isLoggedIn ? "Go to Dashboard" : "Get Started for FREE"}
          </IonButton>
          {isLoggedIn ? null : (
            <IonButton
              {...createNavigationProps(LOGIN_MENU_ITEM.linkTo)}
              fill="outline"
              color="primary"
            >
              Sign into an Existing Account
            </IonButton>
          )}
        </IonRow>
      </IonCol>
      <IonCol className="intro-side ion-hide-lg-down">
        <IonImg
          src="fireplane_hero_graphic.svg"
          className="intro-plane"
        ></IonImg>
      </IonCol>
    </IonRow>
  );
}

export { IntroSection };
